/**
 * @component {"type":"Accordion","version":"1.2"}
 */

define('component-accordion',['knockout', 'helpers', 'utils'], function(ko, helpers, utils) {

    var getHeight = function(total) {
        var container = document.getElementById('accordion-container'),
            accordion = document.getElementById('accordion'),
            height = (container) ? parseInt(container.offsetHeight) : 0,
            bottom = (accordion) ? (Modernizr.flexboxlegacy && container) ? parseInt(helpers.layout.nodeStyle(container, 'paddingTop')) : (parseInt(helpers.layout.nodeStyle(accordion, 'bottom')) || parseInt(helpers.layout.nodeStyle(accordion, 'top'))) : 0,
            inner = (utils.isNumber(bottom)) ? bottom : 0,
            nodes = (container || document).querySelectorAll('.a-head');

        height -= 2*inner;

        for (var i = 0; i < nodes.length; i++) {
            height -= parseInt(nodes[i].offsetHeight);
        }


        return (height < total) ? height : total;
    },
    collapseAccordion = function() {
        var accordion = document.getElementById('accordion-container'),
            active = (accordion || document).querySelector('.a-head-is-open'),
            selector,
            prev;

        if (!active) {
            return;
        }

        active.classList.remove('a-head-is-open');
        selector = (active && active.dataset && active.dataset.selector) ? active.dataset.selector : null;
        prev = (selector) ? document.getElementById(selector) : null;

        if (!prev) {
            return;
        }

        prev.style.height = 0;
    };

    return function(parentVM) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training;

        self.maximum = ko.observable(true);
        self.collapsible = ko.observable(true);

        self.items = ko.computed(function() {
            var content = helpers.component.getContent(entityVM.componentsJSON(), 'Accordion'),
                arr = helpers.component.parseProp(content, 'items', 'AccordionItem') || [],
                interacted = !content.interaction;

            self.maximum(content.maximum);
            // self.collapsible = ko.observable(content.collapsible);  // enable when IE9 dropped

            for (var i = 0; i < arr.length; i++) {
                arr[i].id = 'a-body-' + i;
                arr[i].interacted = interacted.toString();
                arr[i].index = i;
                arr[i].last = (i === arr.length - 1);
            }

            if (window.detachEvent) {
                window.detachEvent('onresize', collapseAccordion);
            } else if(window.removeEventListener) {
                window.removeEventListener('resize', collapseAccordion);
            }

            if (arr.length) {
                if (window.attachEvent) {
                    window.attachEvent('onresize', collapseAccordion);
                } else if(window.addEventListener) {
                    window.addEventListener('resize', collapseAccordion, true);
                }
            }

            return arr;
        });

        self.toggle = function(o, e) {
            var target = e.currentTarget,
                container = document.getElementById('accordion-container'),
                isOpen = (target.classList && target.classList.contains('a-head-is-open')) ? true : false,
                selector = (target && target.dataset && target.dataset.selector) ? target.dataset.selector : null,
                body = (selector) ? document.getElementById(selector) : null,
                content, inner,
                height = 0,
                flexible = window.getComputedStyle(document.getElementById('player'), ':after').getPropertyValue('content').replace(/\"/g, '');

            target.removeAttribute('data-interacted');

            trainingVM.updateVisited();

            if (!body) {
                return;
            }

            if (isOpen) {

                target.classList.remove('a-head-is-open');
                body.style.height = 0;

            } else {

                if (self.maximum() && flexible && flexible === 'js-cols') {

                    height = parseInt(container.offsetHeight);

                    height = (Modernizr.flexbox || Modernizr.flexboxtweener) ? height : getHeight(height);

                } else {
                    content = body.querySelector('.js-content') || null;

                    if (!content) {
                        return;
                    }

                    inner = content.querySelector('div:first-child') || null;

                    if (!inner) {
                        return;
                    }

                    height = parseInt(helpers.layout.nodeStyle(inner, 'marginTop')) + parseInt(helpers.layout.nodeStyle(inner, 'marginBottom')) + parseInt(inner.offsetHeight);

                    height = (Modernizr.flexbox || Modernizr.flexboxtweener) ? height : (flexible && flexible === 'js-cols') ? getHeight(height) : height;
                }

                if (self.collapsible()) {
                    collapseAccordion();
                }

                target.classList.add('a-head-is-open');
                body.style.height = height + 'px';

            }
        };

    };

});

